(() => {
  const wishListInjector = document.querySelector('.hidden-wishlist-btn .wkh-button');
  const wishListCounters = document.querySelectorAll('.js-wishlist-counter');

  if (wishListInjector === null || wishListCounters.length === 0) {
    return;
  }

  const populateWishlistCounter = () => {
    wishListCounters.forEach((counter) => {
      const hiddenCounter = /** @type {HTMLElement | null} */ (
        wishListInjector.querySelector('.wkh-counter')
      );
      if (hiddenCounter === null) {
        return;
      }

      const countNumber = parseInt(hiddenCounter.innerText, 10);
      if (Number.isNaN(countNumber)) {
        return;
      }
      const isHeaderWishlistCounter = counter.parentElement?.classList.contains(
        'header-actions__wishlist-button'
      );
      const counterTextCount = /** @type {HTMLElement | null} */ (
        counter.querySelector('.wishlist-bubble__text-count, .wishlist-heading__text-count')
      );
      if (counterTextCount === null) {
        return;
      }

      if (countNumber > 99 && isHeaderWishlistCounter) {
        counterTextCount.innerText = '99+';
      } else {
        counterTextCount.innerText = String(countNumber);
      }

      counter.classList.toggle('hidden', countNumber === 0);
    });
  };

  const observerOptions = {
    childList: true,
    subtree: true,
  };

  const observer = new MutationObserver(() => {
    populateWishlistCounter();
  });

  observer.observe(wishListInjector, observerOptions);
  populateWishlistCounter();
})();
